import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(prop) => (prop.center ? 'center' : 'justify-content')};
  flex-direction: column;
  height: 100%;
  padding-top: 20px;
  padding: 20px 16px 0px 16px;
  div[data-label='cliNationality'] {
    .MuiListItem-root {
      border: 1px solid ${(props) => (props.error ? '#f44336' : '#555555')} !important;
    }
    .MuiCollapse-wrapperInner {
      .MuiListItem-root {
        height: 40px;
        border: 1px solid transparent !important;
      }
      .MuiListItem-root:hover {
        span {
          color: #00377d;
        }
      }
    }
  }

  button {
    width: 124px;
    height: 36px;
    min-height: 30px;
    max-width: 124px;
    border-radius: 18px;
    box-shadow: none;
  }
  .form-row {
    button {
      min-width: 62px !important;
      max-width: 62px !important;
      padding: 0px !important;
    }
  }
  .formbuilder-btn-group {
    justify-content: center;
    margin-bottom: 20px;
  }
  .MuiCollapse-wrapperInner {
    .MuiListItem-root {
      height: 40px;
      border: 1px solid transparent !important;
    }
    .MuiListItem-root:hover {
      span {
        color: #00377d;
      }
    }
  }
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 38px 10px 38px;
  label {
    text-align: center;
    font-size: 24px;
    line-height: 28px;
  }
`;
